import React from "react";
import { CloseButton, Modal } from "react-bootstrap";
import "./editBidModalForTargetinng.css";
import { useState, useEffect, useMemo } from "react";

import RadioButtonRb from "../Buttons/radioButtonRb/radioButtonRb";
// import "./editBidModal.css";
import plusIcon from "../../assets/icons/plus-sign.png";
import minusIcon from "../../assets/icons/minus-sign.png";
import SecondaryBtnRb from "../Buttons/secondaryBtnRb/secondaryBtnRb";
import { useDispatch, useSelector } from "react-redux";
import { campaignListActions } from "../../redux/slices/campaignList.js";
import { calculateAfterBid } from "../../helper/common/modifyValueByPercentage";

const formatBidValue = (value) => {
  if (value === null || value === undefined || value === "" || isNaN(value)) {
    return "N/A";
  }
  return Number(parseFloat(value).toFixed(2));
};

export default function EditBidModalWithAbsoluteValue(props) {
  const dispatch = useDispatch();
  const [isVisible, setisVisible] = useState(false);
  const [selectedActionForbidEdit, setSelectedActionForbidEdit] = useState("");
  const [increaseByInputValue, setincreaseByInputValue] = useState(5);
  const [decreaseByInputValue, setdecreaseByInputValue] = useState(5);
  const [absIncreaseByInputValue, setabsIncreaseByInputValue] = useState(5);
  const [absDecreaseByInputValue, setabsDecreaseByInputValue] = useState(5);
  const [setBidAsValue, setSetBidAsValue] = useState("");
  const [valueToUpdateBidby, setvalueToUpdateBidby] = useState("");
  const targetCheckedForBulkEdit = useSelector(
    (state) => state.campaignListData.targetCheckedForBulkEdit
  );
  const checkedTargetDataForBulEdit = useSelector(
    (state) => state.campaignListData.checkedTargetDataForBulEdit
  );

  const cpcKey = props?.cpcKey || "agg_cpc";
  const previewRows = props?.previewRows || [];

  const bidPreviewData = useMemo(() => {
    if (!selectedActionForbidEdit || !previewRows?.length) {
      return [];
    }
    return previewRows.map((row, index) => {
      const currentBid = row?.current_bid;
      const cpcValue = row?.[cpcKey];
      const afterBid = calculateAfterBid({
        selectedAction: selectedActionForbidEdit,
        valuePercentage: valueToUpdateBidby,
        setAsValue: setBidAsValue,
        currentBid,
        cpcValue,
      });
      return {
        id: row?.target_id || row?.id || index,
        targeting: row?.targeting || "-",
        currentBid,
        cpcValue,
        afterBid,
      };
    });
  }, [
    selectedActionForbidEdit,
    previewRows,
    valueToUpdateBidby,
    setBidAsValue,
    cpcKey,
  ]);

  const hasValidPreviewUpdates = bidPreviewData.some(
    (row) => row.afterBid !== null && row.afterBid > 0
  );

  const isButtonDisable =
    (selectedActionForbidEdit === "increase-by" && increaseByInputValue === 0) ||
    (selectedActionForbidEdit === "decrease-by" && decreaseByInputValue === 0) ||
    (selectedActionForbidEdit === "set_bid_as" &&
      props?.setBidAsZeroDisable &&
      (setBidAsValue === "" || setBidAsValue === "0")) ||
    (selectedActionForbidEdit === "copy_cpc" && !hasValidPreviewUpdates);

  const handelClick = () => {
    props.SetShowModal(!props.ShowModal);
  };

  useEffect(() => {
    dispatch(campaignListActions.actionEditCollectiveBidForMasterTargeting({}));
  }, []);

  useEffect(() => {
    if (selectedActionForbidEdit === "increase-by") {
      setvalueToUpdateBidby(increaseByInputValue);
    } else if (selectedActionForbidEdit === "set_bid_as") {
      setvalueToUpdateBidby(setBidAsValue);
    } else if (selectedActionForbidEdit === "increase-by-abs") {
      setvalueToUpdateBidby(absIncreaseByInputValue);
    } else if (selectedActionForbidEdit === "decrease-by-abs") {
      setvalueToUpdateBidby(absDecreaseByInputValue);
    } else if (selectedActionForbidEdit === "copy_cpc") {
      setvalueToUpdateBidby(null);
    } else {
      setvalueToUpdateBidby(decreaseByInputValue);
    }
  }, [increaseByInputValue, decreaseByInputValue, selectedActionForbidEdit, absIncreaseByInputValue, absDecreaseByInputValue, setBidAsValue]);

  const plusButtonHandler = (type) => {
    switch (type) {
      case "increaseBy":
        setincreaseByInputValue(
          (increaseByInputValue) => increaseByInputValue + 1
        );
        break;
      case "decreaseBy":
        setdecreaseByInputValue(
          (decreaseByInputValue) => decreaseByInputValue + 1
        );
        break;
      case "increaseByAbs":
        setabsIncreaseByInputValue(
          (absIncreaseByInputValue) => absIncreaseByInputValue + 1
        );
        break;
      case "decreaseByAbs":
        setabsDecreaseByInputValue(
          (absDecreaseByInputValue) => absDecreaseByInputValue + 1
        );
        break;
      default:
        break;
    }
  };

  const minusButtonHandler = (type) => {
    switch (type) {
      case "increaseBy":
        if (!increaseByInputValue == 0) {
          setincreaseByInputValue(
            (increaseByInputValue) => increaseByInputValue - 1
          );
        }
        break;
      case "decreaseBy":
        if (!decreaseByInputValue == 0) {
          setdecreaseByInputValue(
            (decreaseByInputValue) => decreaseByInputValue - 1
          );
        }
        break;
      case "increaseByAbs":
        if (!absIncreaseByInputValue == 0) {
          setabsIncreaseByInputValue(
            (absIncreaseByInputValue) => absIncreaseByInputValue - 1
          );
        }
        break;
      case "decreaseByAbs":
        if (!absDecreaseByInputValue == 0) {
          setabsDecreaseByInputValue(
            (absDecreaseByInputValue) => absDecreaseByInputValue - 1
          );
        }
        break;
      default:
        break;
    }
  };

  const setBidAsValueDataHandler = (e) => {
    if((parseFloat(e.target.value) < 0 || isNaN(parseFloat(e.target.value))) && e.target.value !== "") { 
      return;
    }
    setSetBidAsValue(e.target.value);
  };

  const onSelecthandler = (e) => {
    setSelectedActionForbidEdit(e.target.id);
  };

  function resetToInitialStates () {
    setincreaseByInputValue(5);
    setdecreaseByInputValue(5);
    setabsDecreaseByInputValue(5);
    setabsIncreaseByInputValue(5);
    setSelectedActionForbidEdit("")
    setSetBidAsValue("")
    setvalueToUpdateBidby("")
  }

  const onupdateClickHandler = () => {
    dispatch(campaignListActions.hideBulkeditBidModal());
    dispatch(
      campaignListActions.actionEditCollectiveBidForMasterTargeting({
        selectedAction: selectedActionForbidEdit,
        valuePercentage: valueToUpdateBidby,
        targetIdsToChagedbid: checkedTargetDataForBulEdit,
        setAsValue:
          selectedActionForbidEdit === "set_bid_as" ? setBidAsValue : null,
      })
    );
    resetToInitialStates()
  
    if(props.getData) {
      const data = {
        selectedAction: selectedActionForbidEdit,
        valuePercentage: valueToUpdateBidby,
        targetIdsToChagedbid: checkedTargetDataForBulEdit,
        setAsValue:
          selectedActionForbidEdit === "set_bid_as" ? setBidAsValue : null,
        cpcKey: props?.cpcKey || "agg_cpc",
      }

      props.getData(data)
    }
    if(props.cancel) {
      props.cancel();
    }
  };
  const cancelHandler = () => {
    dispatch(campaignListActions.hideBulkeditBidModal());
    // dispatch(campaignListActions.actionEditCollectiveBidForMasterTargeting({}));
    if(props.cancel) {
      props.cancel();
    }
    resetToInitialStates()
  };

  const hasPreview = previewRows?.length > 0;

  let modalBody = (
    <div className={`bid-config-modal-container bid-config-modal-layout ${hasPreview ? "bid-config-modal-with-preview" : ""}`}>
      <div className="edit-bid-heading position-relative">Edit Collective Bid 
    { props?.detailedText ?  <span className="position-absolute text-center" style={{right:90,fontSize:10,bottom:0 ,...(props?.detailedTextStyles ? props.detailedTextStyles : {})}}>
      <span className="text-danger">*</span> {props?.detailedText}</span> : null}
      <CloseButton className="position-absolute" style={{right:2,top:15,fontSize:'16px'}} onClick={cancelHandler}/>
      </div>
      <div className="bid-config-modal-scrollable">
      <div className="d-flex justify-content-center flex-column align-items-center targeting-bid-config-content-containet gap-2">
        <div className={`p-3 targeting-actions-container ${props?.isPercentageFieldsDisabled ? 'disable-pointer-events':''}`}>
        <span>Percentage (%)</span>
        <div className="targeting-actions p-2 mt-1">
        <div className="targeting-bid-config-container align-items-center">
          <span>
            <RadioButtonRb
              className="action-by-btn cursor-pointer-global"
              onChange={onSelecthandler}
              checked={selectedActionForbidEdit === "increase-by"}
              id="increase-by"
              name="collective-bid"
              label="Increase by"
            ></RadioButtonRb>
          </span>
          <span className="percetage-config-container">
            <span onClick={() => plusButtonHandler("increaseBy")}  className="cursor-pointer-global">
              <img src={plusIcon} alt={"increase"}></img>
            </span>
            <span className="d-flex justify-center actionn-text">
              <input
                className="bid-number"
                type="text"
                disabled={selectedActionForbidEdit !== "increase-by"}
                value={increaseByInputValue + "%"}
                onChange={(e) => {
                  const withoutSymbol = e.target.value?.replace(/%/g, '');
                  setincreaseByInputValue(Number(withoutSymbol))
                }}
              ></input>
            </span>
            <span onClick={() => minusButtonHandler("increaseBy")}  className="cursor-pointer-global">
              <img src={minusIcon} alt={"decrease"}></img>
            </span>
          </span>
        </div>
        <div className="targeting-bid-config-container align-items-center">
          <span>
            <RadioButtonRb
              className="action-by-btn"
              name="collective-bid"
              id="decrease-by"
              checked={selectedActionForbidEdit === "decrease-by"}
              label="Decrease by"
              onChange={onSelecthandler}
            ></RadioButtonRb>
          </span>
          <span className="percetage-config-container">
            <span>
              <img
              className="cursor-pointer-global"
                src={plusIcon}
                onClick={() => plusButtonHandler("decreaseBy")}
                alt={"decrease"}
              ></img>
            </span>
            <span className="d-flex justify-center">
              <input
                className="bid-number"
                type="text"
                value={decreaseByInputValue + "%"}
                disabled={selectedActionForbidEdit !== "decrease-by"}
                onChange={(e) =>{ 
                  const withoutSymbol = e.target.value?.replace(/%/g, '');
                  setdecreaseByInputValue(Number(withoutSymbol))
                }}
              ></input>
            </span>
            <span onClick={() => minusButtonHandler("decreaseBy")}  className="cursor-pointer-global">
              <img  src={minusIcon} alt={"decrease"}></img>
            </span>
          </span>
        </div>
        </div>

        </div>
        <div className="p-3 targeting-actions-container">
        <span>Absolute Value</span>
        <div className="targeting-actions p-2 mt-1">
        <div className="targeting-bid-config-container">
          <span>
            <RadioButtonRb
              className="action-by-btn cursor-pointer-global"
              onChange={onSelecthandler}
              checked={selectedActionForbidEdit === "increase-by-abs"}
              id="increase-by-abs"
              name="collective-bid"
              label="Increase by"
            ></RadioButtonRb>
          </span>
          <span className="percetage-config-container">
            <span onClick={() => plusButtonHandler("increaseByAbs")}  className="cursor-pointer-global">
              <img src={plusIcon} alt={"increase"}></img>
            </span>
            <span className="d-flex justify-center actionn-text">
              <input
                className="bid-number"
                type="text"
                disabled={selectedActionForbidEdit !== "increase-by-abs"}
                value={absIncreaseByInputValue}
                onChange={(e) => {
                  const withoutSymbol = e.target.value?.replace(/%/g, '');
                  setabsIncreaseByInputValue(Number(withoutSymbol))
                }}
              ></input>
            </span>
            <span onClick={() => minusButtonHandler("increaseByAbs")}  className="cursor-pointer-global">
              <img src={minusIcon} alt={"decrease"}></img>
            </span>
          </span>
        </div>
        <div className="targeting-bid-config-container">
          <span>
            <RadioButtonRb
              className="action-by-btn"
              name="collective-bid"
              id="decrease-by-abs"
              checked={selectedActionForbidEdit === "decrease-by-abs"}
              label="Decrease by"
              onChange={onSelecthandler}
            ></RadioButtonRb>
          </span>
          <span className="percetage-config-container">
            <span>
              <img
              className="cursor-pointer-global"
                src={plusIcon}
                onClick={() => plusButtonHandler("decreaseByAbs")}
                alt={"decrease"}
              ></img>
            </span>
            <span className="d-flex justify-center">
              <input
                className="bid-number"
                type="text"
                value={absDecreaseByInputValue}
                disabled={selectedActionForbidEdit !== "decrease-by-abs"}
                onChange={(e) =>{ 
                  const withoutSymbol = e.target.value?.replace(/%/g, '');
                  setabsDecreaseByInputValue(Number(withoutSymbol))
                }}
              ></input>
            </span>
            <span onClick={() => minusButtonHandler("decreaseByAbs")}  className="cursor-pointer-global">
              <img  src={minusIcon} alt={"decrease"}></img>
            </span>
          </span>
        </div>
        </div>

        </div>
        {
          props.setBidAs &&
        <div className="targeting-bid-config-container">
          <span className="targeting-edit-bid-set-bid-box">
            <RadioButtonRb
              className="action-by-btn"
              name="collective-bid"
              checked={selectedActionForbidEdit === "set_bid_as"}
              id="set_bid_as"
              label="Set Bid as"
              onChange={onSelecthandler}
            ></RadioButtonRb>
          </span>
          <span className=" targeting-edit-bid-set-bid-cal-box">
            {/* <span className="percetage-config-container">
                        <span><img src={plusIcon} onClick={() => plusButtonHandler("decreaseBy")}></img></span>
                        <span className="d-flex justify-center"><input className="bid-number" type="text" value={decreaseByInputValue + "%"} disabled={selectedActionForbidEdit !== "decrease-by"} onChange={e => setdecreaseByInputValue(e.target.value)}></input></span>
                        <span onClick={() => minusButtonHandler("decreaseBy")}><img src={minusIcon}></img></span>
                    </span> */}
            <input
              type="text"
              value={setBidAsValue}
              placeholder=""
              className="set-as-iput-text"
              onChange={setBidAsValueDataHandler}
            ></input>
          </span>
        </div>
}
        {props?.showCopyCpc && (
          <div className="copy-cpc-option-container">
            <RadioButtonRb
              className="action-by-btn"
              name="collective-bid"
              checked={selectedActionForbidEdit === "copy_cpc"}
              id="copy_cpc"
              label="Copy CPC"
              onChange={onSelecthandler}
            ></RadioButtonRb>
            <span className="copy-cpc-option-hint">
              Set bid to each row&apos;s CPC value
            </span>
          </div>
        )}
      </div>
      {hasPreview && selectedActionForbidEdit && bidPreviewData.length > 0 && (
        <div style={{maxHeight:300,overflowY:"auto"}} className="bid-update-preview-container">
          <div className="bid-update-preview-heading">Bid Update Preview</div>
          {selectedActionForbidEdit === "copy_cpc" && (
            <div className="bid-update-preview-note">
              Rows with CPC as N/A or below 1 will be skipped.
            </div>
          )}
          <table className="bid-update-preview-table">
            <thead>
              <tr>
                <th>Targeting</th>
                <th>Current Bid</th>
                {selectedActionForbidEdit === "copy_cpc" && <th>CPC</th>}
                <th>After Updated Bid</th>
              </tr>
            </thead>
            <tbody>
              {bidPreviewData.map((row) => (
                <tr key={row.id}>
                  <td className="bid-preview-targeting" title={row.targeting}>
                    {row.targeting}
                  </td>
                  <td>{formatBidValue(row.currentBid)}</td>
                  {selectedActionForbidEdit === "copy_cpc" && <td>{formatBidValue(row.cpcValue)}</td>}
                  <td
                    className={
                      row.afterBid !== null && row.afterBid > 0
                        ? "bid-preview-after"
                        : "bid-preview-skipped"
                    }
                  >
                    {formatBidValue(row.afterBid)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
      <div className="bid-config-modal-footer targeting-btn-container-for-bid">
        <SecondaryBtnRb
          secondaryBtnText="Cancel"
          onClick={cancelHandler}
          className="primary-inactive-btn px-5 mx-3"
        ></SecondaryBtnRb>
        <SecondaryBtnRb
          secondaryBtnText="Save"
          id={props?.confirmationId}
          disabled={selectedActionForbidEdit === "" || isButtonDisable}
          onClick={onupdateClickHandler}
          className={`primary-active-btn px-5 ${selectedActionForbidEdit === "" || isButtonDisable ? "disabled " : ""}`}
        ></SecondaryBtnRb>
      </div>
    </div>
  );

  return (
    <div className="filetr-modal-for-targeting-main-container">
      <Modal
        // class="modal-dialog modal-dialog-centered"
        show={props.show}
        className={`targeting-filter-modal ${hasPreview ? "bid-preview-modal" : ""}`}
        // dialogClassName="modal-90w"
        onHide={cancelHandler}
        // backdrop="edit-bid-for-targetinng-modal"
        backdropClassName="edit-bid-for-targetinng-backdrop"
        contentClassName="edit-bid-for-targetinng-conntennt"
        // keyboard={false}
        // contentClassName="filter-content-class"
        // contentClassName="main-modal-className-for-filter"
        // bsPrefix="modal"

        dialogClassName="edit-bid-for-targetinng-dialogue"
        // modal="edit-bid-for-targetinng-modal"
      >
        <Modal.Body>{modalBody}</Modal.Body>
      </Modal>
    </div>
  );
}
